import React, { useContext } from 'react';
import { ProductContext } from '../../../../store';
import DetailSkeleton from '../../../../components/Skeleton/DetailSkeleton';
import MagentoEditCategory from './Magento/EditCategory';
import BigCommerceEditCategory from './BigCommerce/EditCategory';
import ShopifyEditCategory from './Shopify/EditCategory';
import WooCommerceEditCategory from './WooCommerce/EditCategory';

const PLATFORMS = { MAGENTO: "magento", SHOPIFY: "shopify", BIGCOMMERCE: "bigcommerce", WOOCOMMERCE: "woocommerce", DRUPAL: "drupal" };

const getMerchandisingApiConfig = (platform) => {
	const base = platform === PLATFORMS.MAGENTO ? "ms2" : "ms3";
	const prefix = platform === PLATFORMS.MAGENTO ? "merchandising" : platform;
	const path = (endpoint) => `api/v1/${prefix}/${endpoint}`;
	return { base, prefix, path };
};

const EDIT_CATEGORY_BY_PLATFORM = {
	[PLATFORMS.MAGENTO]: MagentoEditCategory,
	[PLATFORMS.BIGCOMMERCE]: BigCommerceEditCategory,
	[PLATFORMS.SHOPIFY]: ShopifyEditCategory,
	[PLATFORMS.WOOCOMMERCE]: WooCommerceEditCategory,
};

const EditCategory = () => {
	const { currentWebsiteId, websiteData } = useContext(ProductContext);
	const platform = websiteData?.[currentWebsiteId]?.websiteType;
	const apiConfig = platform ? getMerchandisingApiConfig(platform) : null;
	const PageContent = platform ? EDIT_CATEGORY_BY_PLATFORM[platform] : null;

	if (!platform || !apiConfig || !PageContent) return <DetailSkeleton />;

	return <PageContent apiConfig={apiConfig} />;
};

export default EditCategory;